// import {FontLoader} from "three/examples/jsm/loaders/FontLoader";
// import {Group, Mesh} from "three";
import { $ } from '@/Engine/state';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader';
import { Group, Mesh } from 'three';
import { textMaterial } from '@/Engine/Ruler/material';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry';
import { IV3D } from '@/Interfaces/v3d';
import { textFrameName, textMeshName } from '@/Constants/common';



new FontLoader().load('Montserrat_Bold.json', (font) => {
    $.font = font;
});

declare let v3d: IV3D;
export class TextMesh {
    private loader = new FontLoader();
    readonly model: Group=new v3d.Group();
    textMesh!: Mesh;
    textPlane!: Mesh;
    text: string;
    textGeometry: TextGeometry;

    constructor(text:string) {
        if (!$.font) return;
        if (!$.v3dTools) return;
        this._makeMesh(text);
    }

    _makeMesh(text: string) {
        const modelProto = $.v3dTools.getObjectByName(textFrameName);
        const textProto = $.v3dTools.getObjectByName(textMeshName);
        if (!modelProto) {
            console.warn('modelProto is not defined: ', textFrameName);
            return;
        }

        if (!textProto) {
            console.warn('textProto is not defined: ', textMeshName);
            return;
        }

        modelProto.visible = false;
        textProto.visible = false;

        this.textPlane = modelProto.clone();
        this.textMesh = textProto.clone();
        this.textPlane.visible = true;
        this.textMesh.visible = true;

        this.textPlane.position.set(0, 0, 0);
        // this.textMesh.parent.renderOrder = 100;

        this.textMesh.material.depthTest = false;
        this.textMesh.material.depthWrite = false;
        this.textPlane.material.depthTest = false;
        this.textPlane.material.depthWrite = false;
        this.textMesh.renderOrder = 150;
        this.textPlane.renderOrder = 100;

        this._updateTextGeometry(this.textMesh, text);

        this.model.add(this.textMesh);
        this.model.add(this.textPlane);
        this.text = text;
    }

    getTextGeometry(text: string) {
        if (!$.font) return;
        return new v3d.TextGeometry(text, {
            font: $.font,
            size: 0.03,
            height: 0.035,
            // bevelEnabled: true,
            // bevelThickness: 8,
            curveSegments: 5,
        });
    }

    _updateTextGeometry(obj, text) {
        obj.geometry = obj.geometry.cloneWithText(String(text));
    }

    update(text: string) {
        if (!$.v3dTools) return;
        if (this.text === text) return;
        this.text = text;
        // const geometry = this.getTextGeometry(text);
        // if (!geometry) return;
        if (!this.textMesh) {
            this._makeMesh(text);
            return;
            // const modelProto = $.v3dTools.getObjectByName('size_plane');
            // if (!modelProto) {return;}
            //
            // this.textMesh = modelProto.clone();
            // this.textMesh = new v3d.Mesh(geometry, textMaterial);
            // this.textMesh.scale.set(1,1,0.002);
            // this.textMesh.renderOrder = 100;
            // this.model.add(this.textMesh);
        }

        this._updateTextGeometry(this.textMesh, text);
    }

}

